import { createMessageName } from '@formkit/validation';
import { sentence, date, order, list } from '../formatters.mjs';

// packages/i18n/src/locales/ca.ts
var add = "Afegir";
var remove = "Eliminar";
var removeAll = "Eliminar tot";
var incomplete = "Disculpi, no tots els camps estan omplerts correctament.";
var submit = "Enviar";
var noFiles = "Cap fitxer triat";
var moveUp = "Moure amunt";
var moveDown = "Moure avall";
var isLoading = "Carregant...";
var loadMore = "Carregar més";
var next = "Següent";
var prev = "Anterior";
var addAllValues = "Afegir tots els valors";
var addSelectedValues = "Afegeix els valors seleccionats";
var removeAllValues = "Eliminar tots els valors";
var removeSelectedValues = "Elimina els valors seleccionats";
var chooseDate = "Trieu la data";
var changeDate = "Canviar data";
var close = "Tancar";
var open = "Obert";
var accepted = function({
  name
}) {
  return `Si us plau accepti ${name}.`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ha de ser posterior a ${date(args[0])}.`;
  }
  return `${sentence(name)} ha de succeïr al futur.`;
};
var alpha = function({
  name
}) {
  return `${sentence(name)} només pot contenir caràcters alfabètics.`;
};
var alphanumeric = function({
  name
}) {
  return `${sentence(name)} només pot contenir lletres i números.`;
};
var alpha_spaces = function({
  name
}) {
  return `${sentence(name)} només pot contenir lletres i espais.`;
};
var contains_alpha = function({
  name
}) {
  return `${sentence(name)} ha de contenir caràcters alfabètics.`;
};
var contains_alphanumeric = function({
  name
}) {
  return `${sentence(name)} ha de contenir lletres o números.`;
};
var contains_alpha_spaces = function({
  name
}) {
  return `${sentence(name)} ha de contenir lletres o espais.`;
};
var contains_symbol = function({
  name
}) {
  return `${sentence(name)} ha de contenir símbol.`;
};
var contains_uppercase = function({
  name
}) {
  return `${sentence(name)} ha de contenir majúscules.`;
};
var contains_lowercase = function({
  name
}) {
  return `${sentence(name)} ha de contenir minúscules.`;
};
var contains_numeric = function({
  name
}) {
  return `${sentence(name)} ha de contenir números.`;
};
var symbol = function({
  name
}) {
  return `${sentence(name)} ha de ser un símbol.`;
};
var uppercase = function({
  name
}) {
  return `${sentence(name)} només pot contenir lletres majúscules.`;
};
var lowercase = function({
  name
}) {
  return `${sentence(name)} només pot contenir lletres minúscules.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} ha de ser anterior a ${date(args[0])}.`;
  }
  return `${sentence(name)} ha d'estar al passat.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Aquest camp està configurat incorrectament i no pot ésser enviat.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${sentence(name)} ha d'estar entre ${a} i ${b}.`;
};
var confirm = function({
  name
}) {
  return `${sentence(name)} no concorda.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${sentence(name)} no és una data vàlida, si us plau empri el format ${args[0]}`;
  }
  return "Aquest camp està configurat incorrectament i no pot ésser enviat";
};
var date_between = function({
  name,
  args
}) {
  return `${sentence(name)} ha d'estar entre ${date(args[0])} i ${date(args[1])}`;
};
var email = `Si us plau, entri una adreça d'e-mail vàlida.`;
var ends_with = function({
  name,
  args
}) {
  return `${sentence(name)} no acaba amb ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${sentence(name)} no és un valor acceptat.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${sentence(name)} ha de tenir com a mínim un caràcter.`;
  }
  if (min2 == 0 && max2) {
    return `${sentence(name)} ha de ser inferior o igual a ${max2} caràcters.`;
  }
  if (min2 === max2) {
    return `${sentence(name)} ha de tenir una longitud de ${max2} caràcters.`;
  }
  if (min2 && max2 === Infinity) {
    return `${sentence(name)} ha de ser major que o igual a ${min2} caràcters.`;
  }
  return `${sentence(name)} ha d'estar entre ${min2} i ${max2} caràcters.`;
};
var matches = function({
  name
}) {
  return `${sentence(name)} no és un valor permès.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `No pot tenir més de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} ha de ser menys que o igual a ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "No hi ha cap format de fitxer acceptat.";
  }
  return `${sentence(name)} ha de ser del tipus: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `No pot tenir menys de ${args[0]} ${name}.`;
  }
  return `${sentence(name)} ha de ser com a mínim ${args[0]}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” no s'accepta com a ${name}.`;
};
var number = function({
  name
}) {
  return `${sentence(name)} ha de ser un número.`;
};
var require_one = function({
  name,
  node,
  args: inputNames
}) {
  const labels = inputNames.map((name2) => {
    const dependentNode = node.at(name2);
    if (dependentNode) {
      return createMessageName(dependentNode);
    }
    return false;
  }).filter((name2) => !!name2);
  labels.unshift(name);
  return `${labels.join(" o ")} es requereix.`;
};
var required = function({
  name
}) {
  return `${sentence(name)} és obligatori.`;
};
var starts_with = function({
  name,
  args
}) {
  return `${sentence(name)} no comença amb ${list(args)}.`;
};
var url = function() {
  return `Si us plau inclogui una url vàlida.`;
};
var invalidDate = "La data seleccionada no és vàlida.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  contains_alpha,
  contains_alphanumeric,
  contains_alpha_spaces,
  contains_symbol,
  contains_uppercase,
  contains_lowercase,
  contains_numeric,
  symbol,
  uppercase,
  lowercase,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  require_one,
  required,
  starts_with,
  url,
  invalidDate
};
var ca_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, contains_alpha, contains_alpha_spaces, contains_alphanumeric, contains_lowercase, contains_numeric, contains_symbol, contains_uppercase, date_after, date_before, date_between, date_format, ca_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, lowercase, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, require_one, required, starts_with, submit, symbol, uppercase, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=ca.mjs.map